import React, { FormEvent, useEffect } from 'react';
import { UpstreamWebsiteClientInstance } from '../models/organisationModels';
import { SubmitButton } from 'common/components';
import { updateUpstreamClientSettingsRequest } from '../actions/organisationActions';
import { DynamicFieldSet } from 'common/components/deprecated/form';
import { Antd3Form, Antd3FormProps, StyledAntd3Form } from 'common/components/deprecated/antd3';
import { extractUrlsFromFieldValues } from '../helpers';
import { notificationText, showNotification } from 'common/helpers/notifications';
import { v4 as uuid } from 'uuid';

type Props = {
    upstreamClientSettings: UpstreamWebsiteClientInstance;
    organisationId: number;
    dispatch: Function;
};

type EditClientUpstreamProps = Antd3FormProps & Props;

export const EditClientUpstreamComponent: React.FC<EditClientUpstreamProps> = ({
    upstreamClientSettings,
    organisationId,
    dispatch,
    form,
}: EditClientUpstreamProps) => {
    useEffect(() => {
        form.setFieldsValue({
            allowedRedirectUrls: upstreamClientSettings.allowedRedirectUrls,
            allowedWebOrigins: upstreamClientSettings.allowedWebOrigins,
        });
    }, [upstreamClientSettings]);
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        form.validateFields((error, values) => {
            if (error) {
                showNotification({ text: notificationText.Error });
                return;
            }
            const { allowedRedirectUrls, allowedWebOrigins, id } = values;

            const transformedValues = {
                ...values,
                allowedRedirectUrls: extractUrlsFromFieldValues(allowedRedirectUrls),
                allowedWebOrigins: extractUrlsFromFieldValues(allowedWebOrigins),
            };
            dispatch(
                updateUpstreamClientSettingsRequest({
                    organisationId,
                    id: upstreamClientSettings.id,
                    ...transformedValues,
                }),
            );
        });
    };

    return (
        <>
            <StyledAntd3Form header="Edit Upstream Client Settings" onSubmit={handleSubmit}>
                <DynamicFieldSet
                    fieldSetId="allowedRedirectUrls"
                    fieldType="textInput"
                    initialFields={upstreamClientSettings.allowedRedirectUrls.map((url) => ({
                        url,
                    }))}
                    label="Redirect URLs"
                    placeholder="Redirect URL"
                    form={form}
                    tooltip="Redirect URL is the URL that will be used to redirect the user after authentication."
                />
                <DynamicFieldSet
                    fieldSetId="allowedWebOrigins"
                    fieldType="textInput"
                    initialFields={upstreamClientSettings.allowedWebOrigins.map((url) => ({
                        url,
                    }))}
                    label="Allowed Web Origins"
                    placeholder="Allowed Web Origin"
                    form={form}
                    tooltip="Allowed Web Origin is the URL that will be used to redirect the user after authentication."
                />
                <SubmitButton value="Update Upstream Client" />
            </StyledAntd3Form>
        </>
    );
};

export const EditClientUpstream = Antd3Form.create({})(EditClientUpstreamComponent);
